import { BusinessSettingsFieldsCard } from '@/widgets/scenario-business'

import { SettingsTemplateType } from '@/shared/generated'

import { useScenarioSettingActions } from '../lib/useScenarioSettingActions'

export const ScenarioItemBusinessConstraints = ({
	prefix,
}: {
	prefix: string
}) => {
	const actions = useScenarioSettingActions({
		templateType: SettingsTemplateType.ScenarioBusinessConstraints,
	})

	return <BusinessSettingsFieldsCard prefix={prefix} actions={actions} />
}
